enum TextedLogsEnum {
    YES = 'yes',
    NO = 'no',
    UBER_PASS = 'uber_pass',
    UBER_REQUIRED_MANUAL_LOGS_FAILED = 'uber_required_manual_logs_failed',
}

export { TextedLogsEnum };
